import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { PictureDisplay, PictureLoadMethod } from '@freelancer/ui/picture';

@Component({
  standalone: false,
  selector: 'app-featured-brands',
  template: `
    <div class="FeaturedBrands">
      <fl-container>
        <div
          class="FeaturedBrands-content"
          [class.FeaturedBrands-content--padded]="isPadded"
        >
          <h2
            class="text-light text-title-32 FeaturedBrands-header mb-xlarge tablet:mb-large desktop:mb-none desktop:mr-xxlarge"
            i18n="Featured Brands header"
          >
            As featured in
          </h2>
          <div class="FeaturedBrands-logos">
            <div class="FeaturedBrands-logos-row">
              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="The New York Times Logo"
                  i18n-alt="The New York Times brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="52"
                  [width]="375"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo1.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="Business Insider Logo"
                  i18n-alt="Business Insider brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="25"
                  [width]="659"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo2.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="Inc. Logo"
                  i18n-alt="Inc. brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="76"
                  [width]="220"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo3.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="Forbes Logo"
                  i18n-alt="Forbes brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="490"
                  [width]="1955"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo4.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="CNBC Logo"
                  i18n-alt="CNBC brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="635"
                  [width]="860"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo5.svg'"
                ></fl-picture>
              </div>
            </div>
            <div class="FeaturedBrands-logos-row">
              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="Entrepreneur Logo"
                  i18n-alt="Entrepreneur brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="148"
                  [width]="748"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo6.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="BBC Logo"
                  i18n-alt="BBC brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="86"
                  [width]="300"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo7.svg'"
                ></fl-picture>
              </div>

              <div
                class="FeaturedBrands-logos-logo tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
              >
                <fl-picture
                  alt="Engadget Logo"
                  i18n-alt="Engadget brand logo icon alternative text"
                  [boundedHeight]="true"
                  [boundedWidth]="true"
                  [loadMethod]="PictureLoadMethod.LAZY"
                  [height]="222"
                  [width]="1024"
                  [fullWidth]="true"
                  [src]="'seo-sem/featured-brands/feature-logo8.svg'"
                ></fl-picture>
              </div>

              <fl-picture
                class="tablet:mb-large desktop:mb-none tablet:mr-large mb-xlarge"
                alt="VentureBeat Logo"
                i18n-alt="VentureBeat brand logo icon alternative text"
                [display]="PictureDisplay.BLOCK"
                [loadMethod]="PictureLoadMethod.LAZY"
                [height]="16"
                [width]="112"
                [src]="'seo-sem/featured-brands/feature-logo9.svg'"
                [fullWidth]="true"
              ></fl-picture>
            </div>
          </div>
        </div>
      </fl-container>
    </div>
  `,
  styleUrls: ['./featured-brands.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeaturedBrandsComponent {
  PictureDisplay = PictureDisplay;
  PictureLoadMethod = PictureLoadMethod;

  @Input() isPadded: boolean;
}
